(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autosol-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var main = document.querySelector('[data-product-main]');
    if (!main) return;
    var images = main.querySelectorAll('.main-product__main-image');
    var thumbs = document.querySelectorAll('[data-product-thumb]');
    if (images.length < 2 || thumbs.length < 2) return;

    // Hide all but first image
    images.forEach(function (img, i) {
      if (i > 0) img.style.display = 'none';
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-image-index');
        images.forEach(function (img) {
          img.style.display = img.getAttribute('data-image-index') === idx ? 'block' : 'none';
        });
        thumbs.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-current', active ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
